import { useState } from "react";
import { Box, Grid, Text } from "@storyofams/react-ui";
import { RichText } from "~components/common/RichText";
import { RichTextNH } from "../components/RichTextNH";
import { FourColumnTextAccordion } from "./FourColumnTextAccordion";

export const FourColumnTextItem = ({ content, ...props }) => {
  const [open, setOpen] = useState(null);
  return (
    <Box height={"100%"} width={"100%"}>
      <Box display={["none", "block"]} height={"100%"}>
        <Box
          display={"grid"}
          backgroundColor={"grey200"}
          gridTemplateColumns={["repeat(2, 1fr)", "repeat(2, 1fr)"]}
          gridColumnGap={"1px"}
          gridRowGap={"1px"}
          height={"100%"}
        >
          {content.map(({ title, description }, i) => (
            <Box
              key={title}
              height={"100%"}
              backgroundColor={"white"}
              p={i % 2 === 0 ? "40px 20px 40px 40px" : "40px 40px 40px 20px"}
            >
              <Text
                fontFamily="DINPro"
                fontWeight={700}
                fontSize="24px"
                lineHeight="28.8px"
                mb={1}
              >
                {title}
              </Text>
              <RichText
                fontSize={"16px"}
                css={{
                  "*": {
                    lineHeight: "22.4px",
                    color: "#1D1D1BCC !important",
                  },
                }}
                height={"max-content"}
                text={description}
              />
            </Box>
          ))}
        </Box>
      </Box>
      <Box display={["block", "none"]}>
        {content.map(({ title, description }, i) => (
          <Box
            key={i}
            onClick={() => {
              if (open === i) setOpen(null);
              else setOpen(i);
            }}
          >
            <FourColumnTextAccordion
              key={title}
              title={title}
              open={open === i}
              withoutLastBorder={i === content.length - 1}
            >
              <RichTextNH
                fontSize={"16px"}
                lineHeight={"22.4px"}
                height={"max-content"}
                content={{ text: description }}
              />
            </FourColumnTextAccordion>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
